<template>
  <div>
    <transition :name="props.transition" mode="out-in">
      <div :key="index">
        <slot :name="index" />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  index: string
  transition?: string
}
const props = withDefaults(defineProps<Props>(), {
  transition: 'slide-left',
})
</script>
